import React from 'react'
import SectionSkeleton from '@page-components/CheckoutV3/components/SectionSkeleton'

import CouponIcon from './CouponIcon'

export default function CouponSkeleton() {
  return (
    <div className="py-2">
      <SectionSkeleton icon={<CouponIcon />} transparentOnDesktop />
    </div>
  )
}
